{
    "request": {
        "reminder_sent": {
            "title": "Erinnerung",
            "message": "Eine Erinnerung wurde verschickt."
        },
        "reminder_not_sent": {
            "title": "Erinnerung nicht gesendet",
            "message": "Konnte die Erinnerung nicht senden."
        },
        "cancelled": {
            "title": "Gelöscht",
            "message": "Der Antrag wurde gelöscht."
        },
        "approved": {
            "title": "Freigegeben",
            "message": "Der Antrag wurde freigegeben."
        },
        "reviewed": {
            "title": "Geprüft",
            "message": "Der Antrag wurde geprüft."
        },
        "reviewed_bulk": {
            "title": "Geprüft",
            "message": "Die Anträge wurden geprüft."
        },
        "reviewed_bulk_partial": {
            "title": "Teilweise geprüft",
            "message": "Die Anträge wurden teilweise geprüft. Folgende Anträge konnten nicht erfolgreich geprüft werden: {{expenses}}."
        },
        "paid": {
            "title": "Bezahlt",
            "message": "Der Antrag wurde bezahlt."
        },
        "paid_bulk": {
            "title": "Bezahlt",
            "message": "Die Anträge wurden bezahlt."
        },
        "paid_bulk_partial": {
            "title": "Teilweise bezahlt",
            "message": "Die Anträge wurden teilweise bezahlt. Folgende Anträge konnten nicht erfolgreich bezahlt werden: {{expenses}}."
        },
        "exported": {
            "title": "Exportiert",
            "message": "Der Antrag wurde exportiert."
        },
        "exported_bulk": {
            "title": "Exportiert",
            "message": "Die Anträge wurden exportiert."
        },
        "exported_bulk_partial": {
            "title": "Teilweise exportiert",
            "message": "Die Anträge wurden teilweise exportiert. Folgende Anträge konnten nicht erfolgreich exportiert werden: {{expenses}}."
        },
        "async_export_started": {
            "title": "Grosser Export gestartet",
            "message": "Wenn der Export fertig ist, wird die Datei automatisch im Hintergrund heruntergeladen. Sie können die Datei ebenso in der Export Historie herunterladen."
        },
        "async_export_started_partial": {
            "title": "Grosser Export partiell gestartet",
            "message": "Wenn der Export fertig ist, wird die Datei automatisch im Hintergrund heruntergeladen. Sie können die Datei ebenso in der Export Historie herunterladen. Folgende Anträge konnten nicht erfolgreich exportiert werden: {{expenses}}."
        },
        "async_duo_export_started_partial": {
            "title": "DUO Export partiell gestartet",
            "message": "Der Export nach DUO wurde im Hintergrund gestartet. Folgende Anträge wurden dabei herausgefiltert, da sie nicht kompatibel zu DATEV sind: {{expenses}}."
        },
        "async_duo_export_started": {
            "title": "DUO Export gestartet",
            "message": "Der Export nach DUO wurde im Hintergrund gestartet."
        },
        "async_export_failed": {
            "title": "Export fehlgeschlagen"
        },
        "datev_job_status_manual_check": {
            "title": "Info",
            "message": "Exportstatus des DATEV Online Jobs aktualisiert."
        },
        "rejected": {
            "title": "Abgelehnt",
            "message": "Der Antrag wurde abgelehnt.",
            "link": "Antrag ansehen"
        },
        "changes_requested": {
            "title": "Änderungen angefordert",
            "message": "Änderungen wurden erfolgreich angefordert.",
            "link": "Antrag ansehen"
        },
        "created": {
            "title": "Erstellt",
            "message": "Der Antrag wurde erstellt.",
            "link": "Antrag ansehen"
        },
        "created_with_card_processing": {
            "title": "Erstellt",
            "message": "Der Antrag wurde erstellt und die dazugehörige Karte wird vorbereitet. Dies kann bis zu einer Minute dauern."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Der Antrag wurde aktualisiert."
        },
        "tax": {
            "title": "Aktualisiert",
            "message": "Steuerbetrag wurde aktualisiert."
        },
        "already_deleted": {
            "title": "Warnung - Dieser Antrag wurde bereits gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und nur für abhängige Anträge verfügbar."
        },
        "paused_info": {
            "title": "Info - Dieses Abonnement ist pausiert.",
            "message": "Es werden keine wiederkehrende Abrechnungen für pausierte Abonnements automatisch generiert."
        },
        "paused": {
            "title": "Pausiert",
            "message": "Abonnement wurde pausiert."
        },
        "unpaused": {
            "title": "Reaktiviert",
            "message": "Abonnement wurde reaktiviert."
        },
        "reset": {
            "title": "Aktualisiert",
            "message": "Antragsstatus wurde zurückgesetzt."
        },
        "restored": {
            "title": "Wiederhergestellt",
            "message": "Der Antrag wurde wiederhergestellt."
        },
        "archived": {
            "title": "Archiviert",
            "message": "Der Antrag wurde archiviert"
        },
        "unarchived": {
            "title": "Ausarchiviert",
            "message": "Der Antrag wurde ausarchiviert"
        },
        "opos_excluded": {
            "title": "Posten ausgebucht",
            "message": "Der Posten wurde aus der OPOS-Liste ausgeschlossen."
        },
        "opos_included": {
            "title": "Position zurückgeholt",
            "message": "Die Position wurde wieder in die OPOS Liste aufgenommen."
        },
        "opos_included_bulk": {
            "title": "Positionen zurückgeholt",
            "message": "Die Positionen wurden wieder in die OPOS Liste aufgenommen."
        },
        "detached": {
            "title": "Entfernt",
            "message": "Der Antrag wurde von der Reise entfernt."
        },
        "no_access": {
            "title": "Verboten",
            "message": "Sie haben keinen Zugriff auf diese Karte."
        },
        "attached": {
            "title": "Hinzugefügt",
            "message": "Der Antrag wurde der Reise {{folderName}} hinzugefügt."
        },
        "follow_up_set": {
            "title": "Wiedervorlage",
            "message": "Ihre Wiedervorlage wurde erfolgreich für den {{date}} erstellt"
        },
        "delete": {
            "title": "Antrag gelöscht",
            "message": "Antrag #{{expenseNumber}} wurde gelöscht"
        },
        "marked_as_done": {
            "title": "Als erledigt markiert",
            "message": "Der Antrag wurde als erledigt markiert."
        },
        "sync_expense_creditor": {
            "title": "Synchronisation erfolgreich",
            "message": "Der Antrag wurde erfolgreich auf Basis der neuesten Kreditoren-Stammdaten aktualisiert."
        }
    },
    "per_diem": {
        "destination_break_off": {
            "title": "Neue Destinationen für die Verpflegungsmehraufwandspauschalen {{year}}",
            "message": "{{destination}} werden {{year}} nicht mehr weiterhin als eigene Destination unterstützt. Deshalb wird das Datum und die Destination automatisch aktualisiert. Bitte prüfen Sie die Angaben genau. "
        },
        "missing_destination_for_date_range": "Fehlendes Ziel für Datumsbereich"
    },
    "invoice_inbox": {
        "expense_attached": {
            "title": "Erfolg",
            "message": "Rechnung aus dem Eingang wurde dem Antrag zugeordnet."
        },
        "deleted": {
            "title": "Erfolg",
            "message": "Rechnung wurde erfolgreich gelöscht."
        },
        "auto_matched": {
            "title": "Info",
            "message": "Rechnung \"{{fileName}}\" aus der Inbox wurde mit dem Antrag #{{expenseNumber}} automatisch gemacht."
        },
        "move": {
            "title": "Erfolg",
            "message": "Die Rechnung {{name}} wurde erfolgreich in die Firma {{company}} verschoben."
        },
        "assign": {
            "title": "Erfolg",
            "message": "Das Dokument {{name}} wurde {{employee}} erfolgreich zugewiesen."
        },
        "unassign": {
            "title": "Erfolg",
            "message": "Das Dokument {{name}} ist nicht mehr {{employee}} zugewiesen."
        },
        "change_document_type": {
            "title": "Erfolg",
            "message": "Der Dokumenttyp für {{name}} wurde in {{documentType}} geändert und OCR wurde neu gestartet."
        }
    },
    "bug_report": {
        "title": "Erfolg",
        "message": "Feedback wurde abgesendet."
    },
    "file": {
        "uploaded": {
            "title": "Datei(en) hochgeladen",
            "message": "Die Datei(en) wurde(n) hochgeladen."
        },
        "deleted": {
            "title": "Datei gelöscht",
            "message": "Die Datei wurde gelöscht."
        }
    },
    "comment": {
        "saved": {
            "title": "Erfolg",
            "message": "Kommentar gespeichert."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Kommentar aktualisiert."
        },
        "deleted": {
            "title": "Erfolg",
            "message": "Kommentar gelöscht."
        }
    },
    "subscription": {
        "deleted": {
            "title": "Erfolg",
            "message": "Abonnement wurde gelöscht."
        },
        "already_deleted": {
            "title": "Warnung - Dieses Abonnement wurde bereits gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und nur für abhängige Anträge verfügbar."
        },
        "card_invalid": {
            "title": "Aktion erforderlich – Die Zahlungskarte für dieses Abonnement ist nicht mehr gültig.",
            "message": "Bitte entfernen Sie die aktuelle Karte und fügen Sie eine neue hinzu, um Unterbrechungen Ihres Abonnements zu vermeiden.",
            "removed": {
                "title": "Erfolg",
                "message": "Die Zahlungskarte wurde von diesem Abonnement entfernt."
            }
        }
    },
    "transaction": {
        "deleted": {
            "title": "Erfolg",
            "message": "Transaktion wurde gelöscht."
        },
        "bulk_deleted": {
            "title": "Erfolg",
            "message": "Transaktionen wurden gelöscht."
        },
        "update_category": {
            "title": "Erfolg",
            "message": "Transaktionskategorie wurde geändert."
        }
    },
    "vendor": {
        "created": {
            "title": "Erstellt",
            "message": "Lieferant wurde erstellt."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Lieferant wurde aktualisiert."
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Lieferant wurde gelöscht."
        },
        "restored": {
            "title": "Wiederhergestellt",
            "message": "Lieferant wurde wiederhergestellt."
        },
        "approved": {
            "title": "Freigegeben",
            "message": "Lieferant wurde freigegeben."
        },
        "rejected": {
            "title": "Abgelehnt",
            "message": "Lieferant wurde abgelehnt."
        },
        "already_deleted": {
            "title": "Warnung - Dieser Lieferant wurde bereits gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und nur für abhängige Anträge verfügbar."
        },
        "exported_bulk": {
            "title": "Exportiert",
            "message": "Die Lieferanten wurden exportiert."
        }
    },
    "employee": {
        "created": {
            "title": "Erstellt",
            "message": "Mitarbeiter:in wurde erstellt."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Mitarbeiter:in wurde aktualisiert."
        },
        "email_updated": {
            "title": "Email-Adresse Verifikation wird benötigt.",
            "message": "Bitte bestätigen Sie Ihre neue Email-Adresse. Ein Link für die Bestätigung wurde an Ihre neue Email-Adresse verschickt."
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Mitarbeiter:in wurde gelöscht."
        },
        "restored": {
            "title": "Wiederhergestellt",
            "message": "Mitarbeiter:in wurde wiederhergestellt."
        },
        "already_deleted": {
            "title": "Warnung - Mitarbeiter:in wurde gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und nur für abhängige Anträge verfügbar."
        },
        "invite": {
            "title": "Einladung für Mitarbeiter:in",
            "message": "Mitarbeiter:in in das Unternehmen eingeladen"
        },
        "email_alias_updated": {
            "title": "Erfolg",
            "message": "Email-Alias erfolgreich gesetzt."
        },
        "absence_updated": {
            "title": "Erfolg",
            "message": "Abwesenheit wurde erfolgreich hinterlegt"
        },
        "absence_removed": {
            "title": "Erfolg",
            "message": "Abwesenheit wurde aktualisiert"
        },
        "reset_tfa": {
            "title": "Zurückgesetzt",
            "message": "Die Zwei-Faktor-Authentifizierung wurde für Mitarbeiter:in zurückgesetzt."
        }
    },
    "company_profile": {
        "created": {
            "title": "Erstellt",
            "message": "Firmenprofil für Mitarbeiter:in hinzugefügt."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Firmenprofil für Mitarbeiter:in wurde aktualisiert."
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Firmenprofil für Mitarbeiter:in wurde gelöscht."
        },
        "restored": {
            "title": "Wiederhergestellt",
            "message": "Firmenprofil für Mitarbeiter:in wurde wiederhergestellt."
        }
    },
    "cost_center": {
        "created": {
            "title": "Erstellt",
            "message": "Kostenstelle wurde erstellt."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Kostenstelle wurde aktualisiert."
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Kostenstelle wurde gelöscht."
        },
        "restored": {
            "title": "Wiederhergestellt",
            "message": "Kostenstelle wurde wiederhergestellt."
        },
        "already_deleted": {
            "title": "Warnung - Kostenstelle wurde gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und sind nur für abhängige Anträge verfügbar."
        },
        "exported_bulk": {
            "title": "Exportiert",
            "message": "Die Kostenstellen wurden exportiert."
        }
    },
    "settings": {
        "user_profile": {
            "updated": {
                "title": "Erfolg",
                "message": "Profil wurde erfolgreich aktualisiert."
            }
        },
        "password": {
            "title": "Erfolg",
            "message": "Passwort wurde erfolgreich geändert."
        },
        "expense_account": {
            "updated": {
                "title": "Erfolg",
                "message": "1 Sachkonto wurde erfolgreich aktualisiert.",
                "message_other": "{{count}} Sachkonten wurden erfolgreich aktualisiert."
            },
            "deleted": {
                "title": "Erfolg",
                "message": "1 Sachkonto wurde erfolgreich gelöscht.",
                "message_other": "{{count}} Sachkonten wurden erfolgreich gelöscht."
            },
            "saved": {
                "title": "Erfolg",
                "message": "1 Sachkonto wurde erfolgreich gespeichert.",
                "message_other": "{{count}} Sachkonten wurden erfolgreich gespeichert."
            }
        },
        "cost_center_2": {
            "created": {
                "title": "Erstellt",
                "message": "Kostenstelle wurde erstellt."
            },
            "updated": {
                "title": "Erfolg",
                "message": "1 Kostenträger wurde erfolgreich aktualisiert.",
                "message_other": "{{count}} Kostenträger wurden erfolgreich aktualisiert."
            },
            "deleted": {
                "title": "Erfolg",
                "message": "1 Kostenträger wurde erfolgreich gelöscht.",
                "message_other": "{{count}} Kostenträger wurden erfolgreich gelöscht."
            },
            "saved": {
                "title": "Erfolg",
                "message": "1 Kostenträger wurde erfolgreich gespeichert.",
                "message_other": "{{count}} Kostenträger wurden erfolgreich gespeichert."
            }
        },
        "tools": {
            "updated": {
                "title": "Erfolg",
                "message": "Die allgemeinen Einstellungen wurden aktualisiert."
            }
        },
        "company": {
            "updated": {
                "title": "Erfolg",
                "message": "Firmeneinstellungen wurden erfolgreich aktualisiert."
            },
            "connect_datev": {
                "title": "Info",
                "message": "Bitte schließen Sie die DUO Authentifizierung ab, indem Sie das geöffnete Formular ausfüllen."
            },
            "connected_datev": {
                "title": "Erfolg",
                "message": "DUO wurde erfolgreich verbunden."
            },
            "disconnected_datev": {
                "title": "Warnung",
                "message": "DUO wurde erfolgreich entfernt."
            },
            "custom_bank_subject_updated": {
                "title": "Erfolg",
                "message": "Individiualisierte Verwendungszwecksvorlage wurde erfolgreich aktualisiert."
            },
            "datev_info": {
                "title": "Erfolg",
                "message": "Datev Notiz wurde erfolgreich aktualisiert."
            },
            "datev_csv_config_info": {
                "title": "Erfolg",
                "message": "Konten für DATEV CSV Wallet & Sachkontenlänge erfolgreich aktualisiert."
            },
            "datev_client_and_consultant_info": {
                "title": "Erfolg",
                "message": "DATEV Mandanten- & Beraterinformation erfolgreich aktualisiert."
            },
            "debit_card_limit_buffer_updated": {
                "title": "Erfolg",
                "message": "Limit-Puffer von Debitkarten wurde erfolgreich aktualisiert."
            },
            "fallback_approver": {
                "updated": {
                    "title": "Erfolg",
                    "message": "Ersatz-Genehmiger:in erfolgreich aktualisiert."
                }
            },
            "email_forwarding_address": {
                "copied": {
                    "title": "Erfolg",
                    "message_1": "Email-Weiterleitungsadresse \"",
                    "message_2": "\" wurde in Ihre Zwischenablage kopiert. Sie können Ihre Rechnungen auf diese Adresse weiterleiten, um sie automatisch in die finway Inbox zu importieren."
                }
            },
            "fiscal_year": {
                "title": "Erfolg",
                "message": "Das Geschäftsjahr wurden erfolgreich aktualisiert."
            },
            "aborted_datev_setup": {
                "title": "Warnung",
                "message": "DATEV Unternehmen online Setup wurde abgebrochen."
            }
        },
        "csv_template": {
            "saved": {
                "title": "Erfolg",
                "message": "CSV Vorlage wurde erfolgreich gespeichert."
            },
            "deleted": {
                "title": "Erfolg",
                "message": "CSV Vorlage wurde erfolgreich gelöscht."
            }
        },
        "tax": {
            "updated": {
                "title": "Erfolg",
                "message": "MwSt. erfolgreich aktualisiert."
            },
            "connect_datev": {
                "title": "Info",
                "message": "Bitte schließen Sie die DUO Authentifizierung ab, indem Sie das geöffnete Formular ausfüllen."
            },
            "connected_datev": {
                "title": "Erfolg",
                "message": "DUO wurde erfolgreich verbunden."
            },
            "disconnected_datev": {
                "title": "Warnung",
                "message": "DUO wurde erfolgreich entfernt."
            },
            "aborted_datev_setup": {
                "title": "Warnung",
                "message": "DATEV Unternehmen online wurde erfolgreich entfernt."
            }
        },
        "team": {
            "updated": {
                "title": "Erfolg",
                "message": "Abteilung erfolgreich aktualisiert."
            }
        },
        "troubleshooting": {
            "cleared": {
                "title": "Erfolg",
                "message": "Cache und Cookies wurden erfolgreich geleert. Bitte loggen Sie sich wieder ein, um finway weiter zu benutzen."
            }
        },
        "role": {
            "created": {
                "title": "Erfolg",
                "message": "Rolle erfolgreich erstellt."
            },
            "updated": {
                "title": "Erfolg",
                "message": "Rolle erfolgreich aktualisiert."
            }
        }
    },
    "payment_subscription": {
        "created": {
            "title": "Erfolg",
            "message": "Ein Zahlungsabonnement wurde erstellt."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Ihr Zahlungsabonnement wurde aktualisiert."
        },
        "cancelled": {
            "title": "Erfolg",
            "message": "Ihr Zahlungsabonnement wurde storniert."
        },
        "reactivated": {
            "title": "Erfolg",
            "message": "Ihr Zahlungsabonnement wurde wieder aktiviert."
        },
        "inv_download": {
            "title": "Erfolg",
            "message": "Ihre letzte Rechnung wurde heruntergeladen."
        },
        "deleted": {
            "title": "Erfolg",
            "message": "Ihr Zahlungsabonnement wurde gelöscht."
        }
    },
    "rejection_note": {
        "title": "Begründung der Ablehnung",
        "message": "Bitte geben Sie den Grund für die Ablehnung an.",
        "confirm": "Ablehnen",
        "cancel": "Abbrechen"
    },
    "request_changes": {
        "title": "Warnung",
        "message": "Wenn Sie Änderungen an dieser Anfrage anfordern, wird der Genehmigungsprozess zurückgesetzt und alle bereits erteilten Genehmigungen gehen verloren. Möchten Sie fortfahren?",
        "confirm": "Ja",
        "cancel": "Nein"
    },
    "password_reset": {
        "title": "Passwort zurücksetzen",
        "message": "Ihr Passwort wurde zurückgesetzt."
    },
    "password_set": {
        "title": "Passwort erstellt",
        "message": "Ihr neues Passwort wurde erstellt."
    },
    "password_forgot": {
        "title": "Passwort vergessen",
        "message": "Eine Email zum Wiederherstellen Ihres Passworts wurde gesendet, falls ein:e Mitarbeiter:in mit dieser Email-Adresse existiert."
    },
    "set_new_password_request": {
        "title": "E-Mail Postfach prüfen",
        "message": "Sie können jetzt ein neues Passwort festlegen, bitte überprüfen Sie Ihr E-Mail Postfach."
    },
    "new_api_version": {
        "title": "Neue Version verfügbar",
        "message": "Eine neue Version ist verfügbar. Bitte melden Sie sich erneut an."
    },
    "matching": {
        "csv_upload": {
            "title": "Erfolg",
            "message": "CSV-Datei wurde verarbeitet."
        },
        "csv_upload_info": {
            "title": "Bitte stellen Sie sicher, dass Ihre CSV-Datei die folgenden Pflichtangaben enthält",
            "field_1": "Betrag",
            "field_2": "Datum (der Transaktion)",
            "field_3": "Währung - Bitte den dreistelligen ISO-Währungscode verwenden (z. B. EUR für Euro)."
        },
        "csv_currency_info": {
            "message": "Wenn Ihre CSV keine Währungsspalte hat, fügen Sie bitte eine „Währung“-Spalte hinzu (nutzen Sie 3-stellige ISO-Codes wie EUR). Oder wählen Sie hier eine Standardwährung aus. Falls beides vorhanden ist, werden die Währungsangaben aus der CSV verwendet."
        },
        "bank": {
            "title": "Info",
            "message": "Banktransaktionen werden importiert und ge-matched. Dies kann einige Minuten dauern."
        },
        "title": "Erfolg",
        "message": "Verifizierung wurde durchgeführt.",
        "matched": {
            "title": "Erfolg",
            "message": "Transaktion wurde erfolgreich ge-matched."
        },
        "unmatched": {
            "title": "Erfolg",
            "message": "Transaktion wurde erfolgreich un-matched."
        },
        "need_consent": {
            "title": "Info",
            "message": "Bitte füllen Sie das in der neuen Registerkarte geöffnete Webformular aus, um die Zustimmung zum Abruf Ihrer neuesten Transaktionen zu erteilen. Versuchen Sie dann bitte erneut, die Banktransaktionen abzurufen."
        },
        "hasArchivedTransactions": {
            "title": "Warnung",
            "message": "Die hochgeladenen Transaktionen wurden aufgrund der Archivierungseinstellungen automatisch archiviert."
        }
    },
    "banking": {
        "import_started": {
            "title": "Info",
            "message": "Prozess zur Anbindung der neuen Bankverbindung gestartet. Bitte füllen Sie die Webform aus."
        },
        "imported": {
            "title": "Erfolg",
            "message": "Bankverbindung erfolgreich angebunden. Transktionen werden heruntergeladen."
        },
        "deleted": {
            "title": "Erfolg",
            "message": "Bankverbindung wurde gelöscht."
        },
        "update_started": {
            "title": "Info",
            "message": "Aktualisierungsprozess der Bankverbindung gestartet. Bitte füllen Sie die Webform aus."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Bankverbindung wurde aktualisiert."
        },
        "payment_started": {
            "title": "Info",
            "message": "Bezahlungsprozess gestartet. Bitte füllen Sie die Webform aus."
        },
        "paid": {
            "title": "Erfolg",
            "message": "Zahlung erfolgreich ausgeführt."
        },
        "new_interface_add_started": {
            "title": "Info",
            "message": "Prozess zur Anbindung eines neuen Interfaces gestartet. Bitte füllen Sie die Webform aus."
        },
        "new_interface_added": {
            "title": "Erfolg",
            "message": "Ein weiteres Interface wurde erfolgreich angebunden. Neue Transaktionen werden heruntergeladen."
        },
        "account": {
            "deleted": {
                "title": "Erfolg",
                "message": "Bankaccount wurde gelöscht."
            }
        },
        "downloaded": {
            "title": "Erfolg",
            "message": "Alle Transaktionen wurden erfolgreich heruntergeladen."
        },
        "refresh_payment_status": {
            "title": "Erfolg",
            "message": "Der Zahlungsstatus wurde erfolgreich aktualisiert."
        },
        "amounts_mismatch": {
            "title": "Warnung SEPA-XML Export",
            "message": "Es gibt eine Diskrepanz zwischen den Netto-, MwSt.- und Brutto-Werten."
        },
        "webformurl": {
            "link": "Bank login"
        }
    },
    "expense_filter": {
        "updated": {
            "title": "Erfolg",
            "message": "Antragsfilter aktualisiert."
        }
    },
    "ocr": {
        "processed": {
            "title": "Erfolg",
            "message": "OCR wurde ausgeführt und das Formular aktualisiert."
        },
        "processed_and_updated": {
            "title": "Erfolg",
            "message": "OCR wurde ausgeführt und der Antrag aktualisiert."
        }
    },
    "cards": {
        "kyb": {
            "submit": {
                "title": "Erfolg",
                "message": "Ihre Geschäftsdaten wurden erfolgreich abgesendet und werden nun geprüft."
            }
        },
        "set_pin": {
            "title": "Erfolg",
            "message": "Finway PIN wurde erfolgreich gesetzt."
        },
        "top_up": {
            "title": "Erfolg",
            "message": "Karte wurde erfolgreich aufgeladen."
        },
        "empty": {
            "title": "Erfolg",
            "message": "Karte wurde erfolgreich geleert."
        },
        "pin_request": "PIN anfordern, um Ihre Karte zu aktivieren.",
        "activation_request": "Geben Sie Ihren Verifizierungs-Code ein, um Ihre Karte zu aktivieren.",
        "click": "Klicken Sie",
        "pin_link": "hier zum Aktivieren",
        "pin_resend_email": "hier, um eine erneute Email mit dem Verifizierungscode zu versenden",
        "status": {
            "resumed": {
                "title": "Erfolg",
                "message": "Karte erfolgreich reaktiviert."
            },
            "suspend": {
                "title": "Warnung",
                "message": "Karte erfolgreich pausiert."
            },
            "close": {
                "title": "Warnung",
                "message": "Karte erfolgreich geschlossen."
            },
            "report_stolen": {
                "title": "Warnung",
                "message": "Karte als gestohlen gemeldet."
            },
            "report_lost": {
                "title": "Warnung",
                "message": "Karte als verloren gemeldet."
            }
        },
        "created": {
            "title": "Erfolg",
            "message": "Karte wurde ausgestellt."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Karteneinstellungen erfolgreich aktualisiert."
        },
        "phone_number_updated": {
            "title": "Success",
            "message": "Die Mobiltelefonnummer der Karte erfolgreich aktualisiert."
        },
        "fix_card": {
            "title": "Erfolg",
            "message": "Probleme der Karte erfolgreich behoben."
        },
        "expense_card_creation": {
            "title": "Erfolg",
            "message": "Karte für die Ausgabe wurde erstellt."
        },
        "activated": {
            "title": "Erfolg",
            "message": "Karte wurde aktiviert."
        },
        "verification_email_resent": {
            "title": "Erfolg",
            "message": "Email mit Verifizierungs-Code wurde versandt."
        },
        "all_enrolled": {
            "title": "Erfolg",
            "message": "Alle Benutzer:innen wurden registriert."
        },
        "limit_change_request": {
            "Titel": "Erfolg",
            "message": "Limitänderung erfolgreich angefordert."
        },
        "not_all_enrolled": {
            "title": "Warnung",
            "message": "Nicht alle Benutzer:innen konnten registriert werden."
        },
        "no_access": {
            "title": "Warnung",
            "message": "Sie haben keinen Zugriff auf diese Karte."
        },
        "account_statement_regenerating": {
            "title": "Info",
            "message": "Kontoauszug wird neu generiert. Dies kann ein paar Minuten dauern."
        },
        "pin_unblocked": {
            "title": "Erfolg",
            "message": "PIN wurde erfolgreich entsperrt."
        },
        "card_program_auth_success": {
            "title": "Erfolg",
            "message": "Erfolgreich authentifiziert."
        }
    },
    "reports": {
        "no_data": "Keine Report-Daten",
        "refresh_started": {
            "title": "Reporting-Daten aktualisieren",
            "message": "Daten werden aktualisiert. Bitte haben Sie einen Augenblick gedult."
        },
        "refresh_forbidden": {
            "title": "Reporting-Daten aktualisieren",
            "message": "Daten koennen nur alle {{time1}} Minuten aktualisiert werden. Bitte versuchen Sie es erneut in {{time2}} Minuten."
        }
    },
    "corporate": {
        "setup_user_passcode": {
            "title": "Erfolg",
            "message": "Finway PIN erfolgreich erstellt."
        },
        "verify_email": {
            "title": "Erfolg",
            "message": "Email-Adresse erfolgreich verifiziert."
        },
        "email_verification_code": {
            "title": "Erfolg",
            "message": "Verifizierungscode wurde versandt."
        },
        "verify_mobile": {
            "title": "Erfolg",
            "message": "Mobiltelefonnummer erfolgreich verifiziert."
        },
        "mobile_already_verified": {
            "title": "Erfolg",
            "message": "Diese Mobiltelefonnummer ist schon verifiziert."
        },
        "mobile_verification_code": {
            "title": "Erfolg",
            "message": "Verifizierungscode wurde versandt."
        },
        "enroll_user": {
            "title": "Erfolgreiche Registrierung",
            "message": "User wurde zum Kartenprogramm hinzugefügt."
        },
        "account_created": {
            "title": "Erfolg",
            "message": "Geschäftskonto wurde erfolgreich erstellt."
        },
        "company_details_submitted": {
            "title": "Erfolg",
            "message": "Firmendaten erfolgreich übermittelt."
        }
    },
    "wallet": {
        "wire_sent": {
            "title": "Erfolg",
            "message": "Transfer erfolgreich gestartet."
        },
        "auth_factor_enroll_success": {
            "title": "Erfolg",
            "message": "Gerät erfolgreich registriert."
        },
        "iban_created": {
            "title": "Erfolg",
            "message": "Wallet erfolgreich erstellt."
        }
    },
    "passcode": {
        "recovery_success": {
            "title": "Erfolg",
            "message": "Finway PIN erfolgreich wiederhergestellt."
        },
        "update_success": {
            "title": "Erfolg",
            "message": "Finway PIN erfolgreich aktualisiert."
        }
    },
    "socket": {
        "connection_lost": "Die Verbindung zum Server ist unterbrochen",
        "reconnecting": "Die Verbindung wird wieder hergestellt.",
        "connection_state": "Server-Verbindungsstatus",
        "connected": "Verbunden",
        "retry": "Wiederholen",
        "reload": "Neu laden"
    },
    "workflow": {
        "deleted": {
            "title": "Warnung",
            "message": "Workflow erfolgreich gelöscht."
        },
        "created": {
            "title": "Erfolg",
            "message": "Workflow erfolgreich erstellt."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Workflow erfolgreich aktualisiert."
        }
    },
    "liquidity": {
        "add_scenario": {
            "title": "Erfolg",
            "message": "Neues Szenario wurde erfolgreich hinzugefügt."
        },
        "update_scenario": {
            "title": "Erfolg",
            "message": "Szenario wurde erfolgreich aktualisiert."
        },
        "deleted_scenario": {
            "title": "Erfolg",
            "message": "Szenario wurde gelöscht."
        },
        "add_forecast_rule": {
            "title": "Erfolg",
            "message": "Neues Prognoseregel wurde erfolgreich hinzugefügt."
        },
        "update_forecast_rule": {
            "title": "Erfolg",
            "message": "Prognoseregel wurde erfolgreich aktualisiert."
        },
        "delete_forecast_rule": {
            "title": "Erfolg",
            "message": "Prognoseregel wurde gelöscht."
        }
    },
    "integrations": {
        "get_my_invoices": {
            "title": "Erfolg",
            "message": "GetMyInvoices Integration erfolgreich aktualisiert."
        },
        "personio": {
            "title": "Erfolg",
            "info": "Info",
            "infoText": "Die Datensynchronisation hat begonnen, kann aber einige Zeit in Anspruch nehmen.",
            "message": "Personio integration erfolgreich aktualisiert."
        }
    },
    "transaction_category": {
        "created": {
            "title": "Erfolg",
            "message": "Kategorie erfolgreich hinzugefügt."
        },
        "updated": {
            "title": "Erfolg",
            "message": "Kategorie erfolgreich aktualisiert."
        },
        "deleted": {
            "title": "Erfolg",
            "message": "Kategorie erfolgreich gelöscht."
        }
    },
    "payment_method": {
        "updated": {
            "title": "Erfolg",
            "message": "Zahlungsmethode erfolgreich aktualisiert."
        }
    },
    "payment_settings": {
        "sign_up_banner": {
            "title": "Bitte fügen Sie Ihre Zahlungsmethode hinzu",
            "message": "Wir automatisieren aktuell den Abonnement- und Abrechnungsprozess Ihres finway-Abonnements. Bitte geben Sie dafür Ihre Zahlungsdaten (Karte oder SEPA-Lastschrift-Mandat) in den Einstellungen an. Damit erklären Sie sich mit der automatischen Abbuchung der Kosten Ihres finway-Abonnements einverstanden."
        },
        "automatic_billing": {
            "title": "Automatische Abrechnung",
            "message1": "Machen Sie sich das Leben einfacher und wechseln Sie zur automatischen Abrechnung. Sobald Sie Ihre Zahlungsdaten eingegeben haben aktivieren wir Ihren Plan.",
            "message2": "Damit erklären Sie sich mit der automatischen Abbuchung der Kosten Ihres finway-Abonnements einverstanden."
        }
    },
    "session_expired": {
        "title": "Warnung",
        "message": "Ihre Sitzung ist abgelaufen und Sie wurden wegen Sicherheitsgründen ausgeloggt."
    },
    "import_result": {
        "validate_only": {
            "title": "Validierung abgeschlossen",
            "message": "Die Datenvalidierung wurde abgeschlossen. Überprüfen Sie die Ergebnisse, indem Sie auf die Schaltfläche unten klicken."
        },
        "validation_errors": {
            "title:": "Datenimport abgebrochen",
            "message": "Datenimport abgebrochen, da Validierungsfehler gefunden wurden. Bitte beheben Sie diese und versuchen Sie es erneut."
        },
        "success": {
            "title": "Erfolg",
            "message": "Daten erfolgreich importiert. Überprüfen Sie die Ergebnisse, indem Sie auf die Schaltfläche unten klicken."
        }
    },
    "mass_export": {
        "started": {
            "message": "Export gestartet",
            "description": "Sobald der Export abgeschlossen werden Sie benachrichtigt"
        }
    },
    "trip_folder": {
        "date_error": "Ihre Reise hat den Zeitraum von 3 Monaten überschritten. Wenden Sie sich bitte an Ihr Finanz-Team, da die regulären Pauschalen für Verpflegungsmehraufwand in diesem Fall nicht anwendbar sind.",
        "cancelled": {
            "title": "Gelöscht",
            "message": "Die Riese wurde gelöscht."
        },
        "submitted": {
            "title": "Eingereicht",
            "message": "Die Reise wurde eingereicht"
        },
        "deleted": {
            "title": "Reise gelöscht",
            "message": "Reise #{{expenseNumber}} wurde gelöscht"
        },
        "archived": {
            "title": "Archiviert",
            "message": "Die Reise wurde archiviert."
        },
        "unarchived": {
            "title": "Ausarchiviert",
            "message": "Die Reise wurde ausarchiviert."
        },
        "created": {
            "title": "Erstellt",
            "message": "Die Reise wurde erstellt.",
            "link": "Reise ansehen"
        },
        "rejected": {
            "title": "Abgelehnt",
            "message": "Die Reise wurde abgelehnt.",
            "link": "Reise ansehen"
        },
        "marked_as_done": {
            "title": "Als erledigt markiert",
            "message": "Die Reise wurde als erledigt markiert."
        },
        "exported": {
            "title": "Exportiert",
            "message": "Die Reise wurde exportiert."
        },
        "exported_bulk": {
            "title": "Exportiert",
            "message": "Die Reisen wurden exportiert."
        }
    },
    "mfa": {
        "reset_for_user": {
            "title": "MFA zurückgesetzt",
            "message": "MFA wurde zurückgesetzt für {{employee_name}}"
        }
    },
    "new_version": {
        "title": "Neue finway Version verfügbar",
        "message": "Die Seite wird in {{time}} sek. neu geladen."
    },
    "async_export_started": {
        "title": "Grosser Export gestartet",
        "message": "Wenn der Export fertig ist, wird die Datei automatisch im Hintergrund heruntergeladen. Sie können die Datei ebenso in der Export Historie herunterladen."
    },
    "user_password_reset": {
        "title": "Erfolg",
        "message": "Passwort erfolgreich zurückgesetzt."
    },
    "password": {
        "changed": {
            "title": "Erfolg",
            "message": "Passwort aktualisiert"
        }
    },
    "change_history_export": {
        "start": {
            "title": "Grosser Export gestartet",
            "message": "Wenn der Export fertig ist, wird die Datei automatisch im Hintergrund heruntergeladen. Sie können die Datei ebenso in der Export Historie herunterladen."
        },
        "finish": {
            "title": "Exportiert",
            "message": "Das Änderungsprotokoll wurde exportiert."
        }
    },
    "datev_invoice_csv": {
        "title": "Achtung - Export unvollständig",
        "message": "Die Spalte \"Gegenkonto\" weist möglicherweise leere Zellen auf. Bitte überprüfen Sie die Spalte und überprüfen Sie auch die Export Einstellungen und ergänzen Sie ggf. die Mandanten- & Beraternummer."
    },
    "data_demo_is_being_created": {
        "title": "Success",
        "message": "Neue Demodaten werden erstellt. Dies kann einen Moment dauern. Lehnen Sie sich zurück, gleich ist es geschafft."
    },
    "employee_absence": {
        "substitute_updated": {
            "title": "Erfolg",
            "message": "Ersatzgenehmiger für Abwesenheiten wurde erfolgreich aktualisiert."
        }
    },
    "purchase_order": {
        "already_deleted": {
            "title": "Warnung - Dieser Bestellantrag wurde bereits gelöscht.",
            "message": "Alle Daten sind schreibgeschützt und nur für abhängige Anträge verfügbar."
        },
        "approved": {
            "title": "Freigegeben",
            "message": "Die Bestellung wurde freigegeben."
        },
        "created": {
            "title": "Erstellt",
            "message": "Bestellung erfolgreich als Entwurf erstellt",
            "link": "Bestellung ansehen"
        },
        "createdAndSubmitted": {
            "title": "Erstellt",
            "message": "Bestellung erfolgreich erstellt. Warten auf Freigabe.",
            "link": "Bestellung ansehen"
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Die Bestellung wurde gelöscht."
        },
        "rejected": {
            "title": "Abgelehnt",
            "message": "Die Bestellung wurde abgelehnt."
        },
        "submitted": {
            "title": "In Freigabe",
            "message": "Bestellung wartet jetzt auf Freigabe."
        },
        "reopened": {
            "title": "Status zurückgesetzt",
            "message": "Die Bestellung wurde zurück auf den Status „Lieferung“ gesetzt."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Die Bestellung wurde aktualisiert."
        },
        "summary_exported": {
            "title": "Exportiert",
            "message": "Die Bestellanfrage wurde exportiert."
        }
    },

    "requester_is_same_as_next_approver": "Die/der Antragsteller:in von Antrag #{{expenseNumber}} ist auch als nächste:r Genehmiger:in des Ordners eingetragen. Bitte ändern Sie den/die Genehmiger:in, bevor Sie den Antrag anhängen, oder hängen Sie ihn erst nach Abschluss der Prüfung an.",
    "folder_requester_is_same_as_expense_next_approver": "Antrag #{{expenseNumber}} kann nicht angehängt werden, da die/der Antragsteller:in zugleich als nächste:r Genehmiger:in des Ordners eingetragen ist. Bitte ändern Sie den/die Genehmiger:in oder hängen Sie den Antrag erst nach Abschluss der Prüfung an.",
    "delivery_note": {
        "created": {
            "title": "Erstellt",
            "message": "Lieferschein erfolgreich erstellt",
            "link": "Lieferschein ansehen"
        },
        "deleted": {
            "title": "Gelöscht",
            "message": "Der Lieferschein wurde gelöscht."
        },
        "updated": {
            "title": "Aktualisiert",
            "message": "Der Lieferschein wurde aktualisiert."
        }
    },
    "window": {
        "popup_opening": {
            "title": "Pop-up wird geöffnet",
            "message": "Das Pop-up öffnet sich in einem neuen Tab. Falls es nicht angezeigt wird, erlauben Sie bitte Pop-ups oder klicken Sie auf diesen Link:"
        },
        "popup_blocked": {
            "title": "Pop-up blockiert",
            "message": "Bitte erlauben Sie Pop-ups."
        }
    },
    "table_column_view": {
        "saved": {
            "title": "Ansicht gespeichert",
            "message": "Ihre Spaltenansicht wurde gespeichert."
        }
    }
}
